<template>
    <div class="p-4">
        <div class="d-flex justify-content-between mb-3 align-middle">
            <h2>Gestion des utilisateurs</h2>
            <a class="btn btn-primary align-middle" href="https://aloha.ideal-dev.fr/create-user">Créer un utilisateur</a>
        </div>
        <table class="table table-striped mt-2">
            <thead>
                <tr>
                    <th>Nom et Prénom</th>
                    <th>Uid</th>
                    <th>Mail</th>
                    <th>Description</th>
                    <th>Téléphone</th>
                    <th>#</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="user in users" v-bind:key="user">      
                    <td>{{ user.cn }}</td>
                    <td>{{ user.uid }}</td>
                    <td>{{ user.mail }}</td>
                    <td>{{ user.description }}</td>
                    <td>{{ user.telephoneNumber }}</td>
                    <td><a class="btn btn-light" v-bind:href="`/user/` +  user.uid + `/details`">Voir</a></td>
                </tr>
            </tbody>
        </table>
    </div>
</template>
<script>
import conf from '../../../../config/api.js';

export default {
    data() {
        return {
            conf: conf,
            users: []
        }
    },
    beforeMount() {
        this.axios.get(`${conf.server}/api/ldap/user/all`) // On fait une requête axios en GET vers l'API afin de récupérer tous les utilisateurs
        .then(res => {
            this.users = res.data.data // On stocke les utilisateurs dans la variable users
        })
    }
}
</script>